import api from "../../../../lib/api";
import { ITaCreate, ITaListSearch, IEditTaPayload } from "../../../../types/master/taInterface";

export const createTaApi = async (data: ITaCreate) => {
  return await api.post(`/ta-associate`, data);
};

export const getTaListApi = async (data: ITaListSearch) => {
  return await api.get(`/ta-associate/${data.page}/${data?.pageLimit}?search=${data?.search ?? ""}`);
};

export const getTaDataByIdApi = async (id: number) => {
  return await api.get(`/ta-associate/${id}`);
};

export const editTaDataByIdApi = async (payload: IEditTaPayload) => {
  return await api.put(`/ta-associate/${payload.id}`, payload.data);
};
